/**
 * BlockedCardIcon — Ícono de pago rechazado.
 * Usado para los estados "Tarjeta inválida" y "Tarjeta expirada".
 */
export const BlockedCardIcon = () => (
  <img
    src={`${import.meta.env.BASE_URL}assets/card-status/payment-declined.svg`}
    alt=""
    width="56"
    height="56"
    data-testid="blocked-card-icon"
    style={{ display: 'block' }}
  />
);

/**
 * AddedCardIcon — Ícono de pago exitoso, usado para el estado
 * "Tarjeta agregada con éxito".
 */
export const AddedCardIcon = () => (
  <img
    src={`${import.meta.env.BASE_URL}assets/card-status/easy-payment.svg`}
    alt=""
    width="56"
    height="56"
    data-testid="added-card-icon"
    style={{ display: 'block' }}
  />
);
